import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useInventoryLEPModal = defineStore('inventory_lep_modal', () => {
  const objectIds = ref<number[]>([])
  const open = ref(false)

  /* Фильтр по элементам */
  const elementsFilter = {
    coords: [59.938784, 30.314997],
    types: [111],
    radius: 70000,
  }

  /**
   * Функция открытия модального окна
   * @param ids
   */
  const openModal = (ids: number[]) => {
    objectIds.value = ids
    open.value = true
  }

  return {
    objectIds,
    open,

    openModal,
  }
})
